export const formatNumberToDecimals = (
	value: number | null | undefined,
	decimals: number,
): number | null => {
	if (value === null || value === undefined) {
		return null;
	}
	return parseFloat(value.toFixed(decimals));
};
